export default [
	{
		columnName: 'id',
		columnDisplayName: 'Id',
		display: false
	},
	{
		columnName: 'laborOpNumber',
		columnDisplayName: 'Labor Code',
		columnModifierName: 'labor-code',
		display: true,
		slot: 'laborOpNumber',
		isSortable: true
	},
	{
		columnName: 'description',
		columnDisplayName: 'Description',
		columnModifierName: 'description',
		display: true,
		slot: 'description',
		isSortable: true
	},
	{
		columnName: 'laborNotes',
		columnDisplayName: 'Notes',
		columnModifierName: 'laborNotes',
		display: true,
		slot: 'laborNotes',
		isSortable: true
	},
	{
		columnName: 'flatRateTime',
		columnDisplayName: 'Time',
		columnModifierName: 'flat-rate-time',
		display: true,
		slot: 'flatRateTime',
		isSortable: false
	},
	{
		columnName: 'codeDetails',
		columnDisplayName: 'Code Details',
		columnModifierName: 'code-details',
		display: true,
		slot: 'codeDetails',
		isSortable: false
	},
	{
		columnName: 'imported',
		columnDisplayName: '',
		columnModifierName: 'add-labor-code',
		display: true,
		slot: 'addLaborCode',
		isSortable: false
	}
];
